import {
  QueryClient,
  QueryClientProvider as BaseProvider,
} from '@tanstack/react-query';

import type { WithChildrenProps } from '../types/components/common';
import { queryLogger } from './queryLogger';

const queryClient = new QueryClient({
  logger: queryLogger,
  defaultOptions: {
    queries: {
      staleTime: 5000,
      refetchOnWindowFocus: false,
    },
  },
});

function QueryClientProvider({ children }: WithChildrenProps) {
  return <BaseProvider client={queryClient}>{children}</BaseProvider>;
}

export default QueryClientProvider;
